export default function Contact() {
  return (
    <section id="contact" className="py-16 sm:py-20 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="font-sans text-3xl sm:text-4xl lg:text-5xl font-light text-gray-900 mb-3 sm:mb-4">
            İletişim
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12">
          <div className="space-y-6 sm:space-y-8">
            <div className="flex items-start space-x-4">
              <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center flex-shrink-0">
                <i className="ri-map-pin-line text-2xl sm:text-3xl text-black"></i>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="font-sans text-base sm:text-lg font-semibold text-gray-900 mb-2">Adres</h3>
                <p className="font-sans text-sm sm:text-base text-gray-600 leading-relaxed">
                  Sümer Mahallesi, 2467/1 Sokak, No:1<br />
                  20020 Merkezefendi / Denizli
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center flex-shrink-0">
                <i className="ri-phone-line text-2xl sm:text-3xl text-black"></i>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="font-sans text-base sm:text-lg font-semibold text-gray-900 mb-2">Telefon</h3>
                <p className="font-sans text-sm sm:text-base text-gray-600 space-y-1">
                  <a href="tel:+905070034228" className="hover:text-accent-gold transition-colors block">
                    +90 (507) 003 42 28
                  </a>
                  <a href="tel:+905064911920" className="hover:text-accent-gold transition-colors block">
                    +90 (506) 491 19 20
                  </a>
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center flex-shrink-0">
                <i className="ri-mail-line text-2xl sm:text-3xl text-black"></i>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="font-sans text-base sm:text-lg font-semibold text-gray-900 mb-2">E-posta</h3>
                <p className="font-sans text-sm sm:text-base text-gray-600 break-all">
                  <a href="mailto:d.atolyeservis@gmail.com" className="hover:text-accent-gold transition-colors">
                    d.atolyeservis@gmail.com
                  </a>
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center flex-shrink-0">
                <i className="ri-time-line text-2xl sm:text-3xl text-black"></i>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="font-sans text-base sm:text-lg font-semibold text-gray-900 mb-2">Çalışma Saatleri</h3>
                <p className="font-sans text-sm sm:text-base text-gray-600 leading-relaxed">
                  Pazartesi - Cumartesi: 09:00 - 19:00<br />
                  Pazar: Kapalı
                </p>
              </div>
            </div>
          </div>

          <div className="w-full h-80 sm:h-96 lg:h-full min-h-[400px] rounded-xl sm:rounded-2xl overflow-hidden border border-gray-200">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3152.3456789012345!2d29.0875!3d37.7742!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14c73e8f0e8f0e8f%3A0x0!2zU8O8bWVyIE1haGFsbGVzaSwgMjQ2Ny8xIFNva2FrLCBObzoxLCAyMDAyMCBNZXJrZXplZmVuZGkvRGVuaXpsaQ!5e0!3m2!1str!2str!4v1234567890123!5m2!1str!2str"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Premium Auto Konum"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
}